import { Controller, useFormContext } from "react-hook-form";

import { Grid, Paper, Typography } from "@mui/material";

import { useAuth } from "@/features/authentication";
import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { OutletChartOfAccountSelect } from "@/features/outlet-chart-of-accounts";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

export const EditableFieldsSection = () => {
  // The hub is the acting outlet on this screen, so the cash/bank account is
  // picked from its own chart of accounts — never the paying outlet's.
  const { outlet } = useAuth();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">
            Detail Penerimaan Penjualan
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            control={control}
            name="outletChartOfAccount"
            render={({ field, fieldState }) => (
              <OutletChartOfAccountSelect
                value={field.value}
                onChange={field.onChange}
                outletId={outlet?.id}
                types={[ChartOfAccountTypeEnum.CASH_AND_BANK]}
                TextFieldProps={{
                  label: "Kas & Bank",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih Kas & Bank",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            placeholder="Kosongkan untuk memakai catatan pembayaran pembelian"
            register={register}
            error={!!errors.note}
            helperText={errors.note?.message}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
